import { isString } from 'lodash'
import { FC, ReactElement } from 'react'
import { Container } from './styles'

type TabItem = {
  name: ReactElement | string;
  icon?: ReactElement | string;
}

type TabBarProps = {
  onClick?: (itemIndex: number) => void;
  items: TabItem[];
  activeIndex?: number;
}

const TabBar: FC<TabBarProps> = ({ items, activeIndex, onClick }): ReactElement => {
  return (
    <Container>
      {items.map((item, i) => (
        <li
          key={`tab-bar-${i}`}
          onClick={() => i !== activeIndex && onClick && onClick(i)}
          className={(activeIndex === i || (activeIndex == null && i === 0)) ? 'active' : undefined}
        >
          <div className='tabbar_content'>
            {
              isString(item.icon)
                ? <div className='icon'><img src={item.icon} alt='icone' /></div>
                : item.icon && <div className='icon'>{item.icon}</div>
            }
            {item.name}
          </div>
        </li>
      ))}
    </Container>
  )
}

export default TabBar
